let _authorize = null;
//keys
const REDIRECT_AFTER_LOGIN = "REDIRECT_AFTER_LOGIN";
const LOGIN_FLOW = "LOGIN_FLOW";
const SIGNUP_USER_FORM_DATA = "SIGNUP_USER_FORM_DATA";
//values
const CLASSIC_FLOW = "CLASSIC_FLOW";
const FROM_INVITATION_FLOW = "FROM_INVITATION_FLOW";
const SIGNIN = "SIGNIN";
const SIGNUP = "SIGNUP";

const keys = {
  //Keys
  LOGIN_FLOW,
  SIGNUP_USER_FORM_DATA,
  REDIRECT_AFTER_LOGIN,
};

const consts = {
  //const values
  SIGNIN,
  SIGNUP,
  CLASSIC_FLOW,
  FROM_INVITATION_FLOW,
  
};

const init = ({ authorize }) => {
  !_authorize && (_authorize = authorize);
};

const STATE = {
  [LOGIN_FLOW]: null,
  [SIGNUP_USER_FORM_DATA]: null,
  [REDIRECT_AFTER_LOGIN]: null,
};

const reloadState = (authorize) => {
  if (authorize !== _authorize) {
    return {
      success: false,
      message: "Unauthorized",
      fromError: null,
      errorCode: "unauthorized-error",
      errorKey: 656636,
    };
  }
  return STATE;
};

const setValue = (authorize, keyName, value) => {
  if (authorize !== _authorize) {
    return {
      success: false,
      message: "Unauthorized",
      fromError: null,
      errorCode: "unauthorized-error",
      errorKey: 368156,
    };
  }
  STATE[keyName] = value;
};

const reset = (authorize) => {
  if (authorize !== _authorize) {
    return {
      success: false,
      message: "Unauthorized",
      fromError: null,
      errorCode: "unauthorized-error",
      errorKey: 467042,
    };
  }
  STATE[LOGIN_FLOW] = null;
  STATE[SIGNUP_USER_FORM_DATA] = null;
  STATE[REDIRECT_AFTER_LOGIN] = null;
};

const LoginFlowState = {
  //Keys
  KEYS: { ...keys },
  ...keys,
  //Values
  CONSTS: { ...consts },
  ...consts,
  init,
  reset,
  reloadState,
  setValue,
};

export default LoginFlowState;

export {
  keys as KEYS,
  consts as CONSTS,
  LOGIN_FLOW,
  SIGNUP_USER_FORM_DATA,
  REDIRECT_AFTER_LOGIN,
  CLASSIC_FLOW,
  FROM_INVITATION_FLOW,
  SIGNIN,
  SIGNUP,
};
